const moduleCart={    
    state: {
        clicked:0,
        goodslist:[],
        goodsdetail:{},

        cartlist:[],
        dgoodsid:0,
        levelupmoney:[],
        sellername:'',
        freight:'',
        giftlist:[]
    },
    getters:{
        itemnums:(state)=>(goodsid)=>{
            for(let i=0;i<state.cartlist.length;i++){
                if(goodsid==state.cartlist[i].id){
                    return state.cartlist[i].nums
                }
            }
            return 0
        },
        totalnums:(state)=>(clicked)=>{
            if(!clicked) return 0
            let total=0
            for(let i=0;i<state.cartlist.length;i++){
                total+=state.cartlist[i].nums
            }
            return total
        },
        carttotal:(state)=>(clicked)=>{
            if(!clicked) return 0
            let total=0
            for(let i=0;i<state.cartlist.length;i++){
                total+=state.cartlist[i].nums*state.cartlist[i].nowprice
            }
            return total.toFixed(2)
        },
        basetotal:(state)=>(clicked)=>{   //only used for level up condition ,price changing
            if(!clicked) return 0
            let total=0
            for(let i=0;i<state.cartlist.length;i++){
                total+=state.cartlist[i].nums*state.cartlist[i].price
            }
            return total.toFixed(2)
        }
    },
    mutations: {
        ADD_TO_CART:(state,payload)=>{
            state.clicked++
            let isNew=true
            for(let i=0;i<state.cartlist.length;i++){
                if(payload.goodsItem.id==state.cartlist[i].id){
                    state.cartlist[i].nums=parseInt(state.cartlist[i].nums)+1
                    isNew=false
                    break
               }
            }
            if(isNew) {
                payload.goodsItem['nums']=1 
                state.cartlist.push(payload.goodsItem)
            }
        },
        DEL_FROM_CART:(state,payload)=>{
            state.clicked++
            for(let i=0;i<state.cartlist.length;i++){
                if(payload.goodsItem.id==state.cartlist[i].id){
                    if(state.cartlist[i].nums>=1){
                       state.cartlist[i].nums=parseInt(state.cartlist[i].nums)-1;
                    }else{
                        state.cartlist.splice(i,1);
                    } 
               }
            }
        },
        UPDATE_NOWPRICE:(state,payload)=>{
            state.clicked++
            let pricelevel=payload.pricelevel
            let basetotal=payload.total
            for(let i=0;i<state.levelupmoney.length;i++){
                if(basetotal>=state.levelupmoney[i]["money"]){
                    pricelevel=state.levelupmoney[i]["level"]
                    break
                } 
            }
            if(state.cartlist.length>0){
                for(let i=0;i<state.cartlist.length;i++){
                    state.cartlist[i].nowprice=state.cartlist[i]['price'+pricelevel]
                }
                //only for display
                for(let j=0;j<state.goodslist.length;j++){
                    state.goodslist[j].nowprice=state.goodslist[j]['price'+pricelevel]
                }
                state.goodsdetail.nowprice=state.goodsdetail['price'+pricelevel]
            }
        },
        UPDATE_NUMS:(state,payload)=>{
            state.clicked++
            let isNew=true
            for(let i=0;i<state.cartlist.length;i++){
                if(payload.goodsid==state.cartlist[i].id){
                    state.cartlist[i].nums=payload.goodsnums
                    isNew=false
                    break;
                }
            }
            if(isNew){
                payload.goodsitem['nums']=payload.goodsnums
                state.cartlist.push(payload.goodsitem)
            }
        },
        SET_DGOODS:(state,payload)=>{
            state.dgoodsid=payload.goodsid
        },
        SET_SELLERNAME:(state,payload)=>{
            state.sellername=payload.sellername
        },
        SET_FREIGHT:(state,payload)=>{
            state.freight=payload.freight
        },
        INIT_CART:(state)=>{
            state.cartlist=[]
            state.goodslist=[]
            state.levelupmoney=[]
            state.clicked=0
            state.dgoodsid=0
            state.giftlist=[]
            state.sellername=''
            state.freight=''
            state.goodsdetail={}
        },
        INIT_LEVELUPMONEY:(state,payload)=>{
            state.levelupmoney=payload.levelupmoney
        },
        INIT_GOODSLIST:(state,payload)=>{
            state.goodslist=payload.goodslist
        },
        INIT_GOODSDETAIL:(state,payload)=>{
            state.goodsdetail=payload.goodsdetail
        },
        SET_CARTLIST:(state,payload)=>{
            state.cartlist=payload.cartlist
        },
        SET_GIFTLIST:(state,payload)=>{
            state.giftlist=payload.giftlist
        },
    },
    actions: {
    }
}

export default moduleCart